import React from 'react';
import type { IconProps } from '../types';

export const HelperCombineSubtract = (props: IconProps) => (
  <svg
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
    {...props}
  >
    <path
      d="M17.6459 47.0208C17.1265 47.0208 16.6284 46.8145 16.2611 46.4472C15.8939 46.08 15.6875 45.5819 15.6875 45.0625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.0625 47.0208C45.5819 47.0208 46.08 46.8145 46.4473 46.4472C46.8146 46.08 47.0209 45.5819 47.0209 45.0625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6875 41.1458V39.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5209 47.0208H21.5625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3959 47.0208H27.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.2709 47.0208H33.3125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.1459 47.0208H39.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.1459 15.6875H39.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.0625 15.6875C45.5819 15.6875 46.08 15.8938 46.4473 16.2611C46.8146 16.6283 47.0209 17.1264 47.0209 17.6458"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.0209 21.5625V23.5208"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.0209 27.4375V29.3958"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.0209 33.3125V35.2708"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.0209 39.1875V41.1458"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.93787 35.7708C3.28603 35.7708 2.66058 35.5119 2.19958 35.0511C1.73863 34.5901 1.47897 33.9647 1.47888 33.3128L1.47888 3.93781C1.47888 3.28582 1.73856 2.66055 2.19958 2.19952C2.66061 1.7385 3.28588 1.47882 3.93787 1.47882L33.3129 1.47882C33.9647 1.47891 34.5902 1.73857 35.0511 2.19952C35.512 2.66052 35.7709 3.28597 35.7709 3.93781L35.7709 13.7288C35.7709 14.3807 35.512 15.0061 35.0511 15.4671C34.5902 15.9281 33.9647 16.1877 33.3129 16.1878L17.6459 16.1878C17.2591 16.1878 16.8881 16.3411 16.6146 16.6146C16.3411 16.8881 16.1879 17.259 16.1879 17.6458L16.1879 33.3128C16.1878 33.9647 15.9281 34.5901 15.4672 35.0511C15.0062 35.5119 14.3807 35.7708 13.7289 35.7708L3.93787 35.7708Z"
      fill="hsl(var(--accent))"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.53267 16H5.33239L8.80398 6.54545H9.9858L13.4574 16H12.2571L9.43182 8.04119H9.35795L6.53267 16ZM6.97585 12.3068H11.8139V13.3224H6.97585V12.3068Z"
      fill="currentColor"
    />
    <path
      d="M28.1449 36V26.5455H31.4503C32.1089 26.5455 32.6521 26.6593 33.0799 26.8871C33.5077 27.1117 33.8262 27.4149 34.0355 27.7965C34.2448 28.1751 34.3494 28.5952 34.3494 29.0568C34.3494 29.4631 34.2771 29.7985 34.1325 30.0632C33.9909 30.3279 33.8031 30.5372 33.5692 30.6911C33.3384 30.8449 33.0876 30.9588 32.8168 31.0327V31.125C33.1061 31.1435 33.3969 31.245 33.6893 31.4297C33.9817 31.6143 34.2263 31.879 34.4233 32.2237C34.6203 32.5684 34.7188 32.9901 34.7188 33.4886C34.7188 33.9626 34.611 34.3888 34.3956 34.7674C34.1802 35.146 33.8401 35.446 33.3754 35.6676C32.9106 35.8892 32.3059 36 31.5611 36H28.1449ZM29.2898 34.9844H31.5611C32.3089 34.9844 32.8398 34.8397 33.1538 34.5504C33.4708 34.258 33.6293 33.9041 33.6293 33.4886C33.6293 33.1686 33.5477 32.8731 33.3846 32.6023C33.2215 32.3284 32.9891 32.1098 32.6875 31.9467C32.3859 31.7805 32.0289 31.6974 31.6165 31.6974H29.2898V34.9844ZM29.2898 30.7003H31.4134C31.758 30.7003 32.0689 30.6326 32.3459 30.4972C32.6259 30.3617 32.8475 30.1709 33.0107 29.9247C33.1768 29.6785 33.2599 29.3892 33.2599 29.0568C33.2599 28.6413 33.1153 28.2889 32.826 27.9996C32.5367 27.7073 32.0781 27.5611 31.4503 27.5611H29.2898V30.7003Z"
      fill="currentColor"
    />
  </svg>
);

export const HelperCombineIntersect = (props: IconProps) => (
  <svg
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
    {...props}
  >
    <path
      d="M31.0625 3.9375C31.5598 3.9375 32.0367 4.13504 32.3883 4.48667C32.74 4.83831 32.9375 5.31522 32.9375 5.8125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.8125 3.9375C4.31522 3.9375 3.83831 4.13504 3.48667 4.48667C3.13504 4.83831 2.9375 5.31522 2.9375 5.8125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.9375 9.5625V11.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.4375 3.9375H27.3125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8125 3.9375H21.6875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1875 3.9375H16.0625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5625 3.9375H10.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1875 33.9375H16.0625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5625 33.9375H10.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.8125 33.9375C4.31522 33.9375 3.83831 33.74 3.48667 33.3883C3.13504 33.0367 2.9375 32.5598 2.9375 32.0625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.9375 28.3125V26.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.9375 22.6875V20.8125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.9375 17.0625V15.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.9375 17.0625V15.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.9375 11.4375V9.5625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9375 47.0625C17.4402 47.0625 16.9633 46.865 16.6117 46.5133C16.26 46.1617 16.0625 45.6848 16.0625 45.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.1875 47.0625C44.6848 47.0625 45.1617 46.865 45.5133 46.5133C45.865 46.1617 46.0625 45.6848 46.0625 45.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0625 41.4375V39.5625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5625 47.0625H21.6875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.1875 47.0625H27.3125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.8125 47.0625H32.9375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.4375 47.0625H38.5625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.8125 17.0625H32.9375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.4375 17.0625H38.5625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.1875 17.0625C44.6848 17.0625 45.1617 17.26 45.5133 17.6117C45.865 17.9633 46.0625 18.4402 46.0625 18.9375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.0625 22.6875V24.5625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.0625 28.3125V30.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.0625 33.9375V35.8125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0625 33.9375V35.8125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.0625 39.5625V41.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0625 18.9375C16.0625 18.4402 16.26 17.9633 16.6117 17.6117C16.9633 17.26 17.4402 17.0625 17.9375 17.0625H32.9375V32.0625C32.9375 32.5598 32.74 33.0367 32.3883 33.3883C32.0367 33.74 31.5598 33.9375 31.0625 33.9375H16.0625V18.9375Z"
      fill="hsl(var(--accent))"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.53267 16H5.33239L8.80398 6.54545H9.9858L13.4574 16H12.2571L9.43182 8.04119H9.35795L6.53267 16ZM6.97585 12.3068H11.8139V13.3224H6.97585V12.3068Z"
      fill="currentColor"
    />
    <path
      d="M36.1449 43V33.5455H39.4503C40.1089 33.5455 40.6521 33.6593 41.0799 33.8871C41.5077 34.1117 41.8262 34.4149 42.0355 34.7965C42.2448 35.1751 42.3494 35.5952 42.3494 36.0568C42.3494 36.4631 42.2771 36.7985 42.1325 37.0632C41.9909 37.3279 41.8031 37.5372 41.5692 37.6911C41.3384 37.8449 41.0876 37.9588 40.8168 38.0327V38.125C41.1061 38.1435 41.3969 38.245 41.6893 38.4297C41.9817 38.6143 42.2263 38.879 42.4233 39.2237C42.6203 39.5684 42.7188 39.9901 42.7188 40.4886C42.7188 40.9626 42.611 41.3888 42.3956 41.7674C42.1802 42.146 41.8401 42.446 41.3754 42.6676C40.9106 42.8892 40.3059 43 39.5611 43H36.1449ZM37.2898 41.9844H39.5611C40.3089 41.9844 40.8398 41.8397 41.1538 41.5504C41.4708 41.258 41.6293 40.9041 41.6293 40.4886C41.6293 40.1686 41.5477 39.8731 41.3846 39.6023C41.2215 39.3284 40.9891 39.1098 40.6875 38.9467C40.3859 38.7805 40.0289 38.6974 39.6165 38.6974H37.2898V41.9844ZM37.2898 37.7003H39.4134C39.758 37.7003 40.0689 37.6326 40.3459 37.4972C40.6259 37.3617 40.8475 37.1709 41.0107 36.9247C41.1768 36.6785 41.2599 36.3892 41.2599 36.0568C41.2599 35.6413 41.1153 35.2889 40.826 34.9996C40.5367 34.7073 40.0781 34.5611 39.4503 34.5611H37.2898V37.7003Z"
      fill="currentColor"
    />
  </svg>
);

export const HelperCombineMerge = (props: IconProps) => (
  <svg
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
    {...props}
  >
    <path
      d="M5.79167 32.5625C5.31649 32.5625 4.86077 32.3737 4.52477 32.0377C4.18876 31.7017 4 31.246 4 30.7708V5.68748C4 5.2123 4.18876 4.75658 4.52477 4.42058C4.86077 4.08458 5.31649 3.89581 5.79167 3.89581H30.875C31.3502 3.89581 31.8059 4.08458 32.1419 4.42058C32.4779 4.75658 32.6667 5.2123 32.6667 5.68748V16.4375H43.4167C43.8918 16.4375 44.3476 16.6262 44.6836 16.9622C45.0196 17.2982 45.2083 17.754 45.2083 18.2291V43.3125C45.2083 43.7877 45.0196 44.2434 44.6836 44.5794C44.3476 44.9154 43.8918 45.1041 43.4167 45.1041H18.3333C17.8582 45.1041 17.4024 44.9154 17.0664 44.5794C16.7304 44.2434 16.5417 43.7877 16.5417 43.3125V32.5625H5.79167Z"
      fill="hsl(var(--accent))"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 16.4375C17.8581 16.4375 17.4024 16.6263 17.0664 16.9623C16.7304 17.2983 16.5416 17.754 16.5416 18.2292"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5416 21.8125V23.6042"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7083 16.4375H21.9166"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.0833 16.4375H27.2916"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9167 32.5625H20.125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.2917 32.5625H25.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5416 28.9792V27.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6666 20.0208V21.8125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.875 32.5625C31.3502 32.5625 31.8059 32.3737 32.1419 32.0377C32.4779 31.7017 32.6667 31.246 32.6667 30.7708"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6666 27.1875V25.3958"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.6368 16H6.43651L9.9081 6.54545H11.0899L14.5615 16H13.3612L10.5359 8.04119H10.4621L7.6368 16ZM8.07998 12.3068H12.918V13.3224H8.07998V12.3068Z"
      fill="currentColor"
    />
    <path
      d="M36.249 42V32.5455H39.5544C40.213 32.5455 40.7562 32.6593 41.184 32.8871C41.6118 33.1117 41.9304 33.4149 42.1396 33.7965C42.3489 34.1751 42.4536 34.5952 42.4536 35.0568C42.4536 35.4631 42.3812 35.7985 42.2366 36.0632C42.095 36.3279 41.9073 36.5372 41.6734 36.6911C41.4425 36.8449 41.1917 36.9588 40.9209 37.0327V37.125C41.2102 37.1435 41.501 37.245 41.7934 37.4297C42.0858 37.6143 42.3305 37.879 42.5274 38.2237C42.7244 38.5684 42.8229 38.9901 42.8229 39.4886C42.8229 39.9626 42.7152 40.3888 42.4997 40.7674C42.2843 41.146 41.9442 41.446 41.4795 41.6676C41.0148 41.8892 40.41 42 39.6652 42H36.249ZM37.3939 40.9844H39.6652C40.4131 40.9844 40.944 40.8397 41.2579 40.5504C41.5749 40.258 41.7334 39.9041 41.7334 39.4886C41.7334 39.1686 41.6518 38.8731 41.4887 38.6023C41.3256 38.3284 41.0932 38.1098 40.7916 37.9467C40.49 37.7805 40.133 37.6974 39.7206 37.6974H37.3939V40.9844ZM37.3939 36.7003H39.5175C39.8622 36.7003 40.173 36.6326 40.45 36.4972C40.7301 36.3617 40.9517 36.1709 41.1148 35.9247C41.281 35.6785 41.3641 35.3892 41.3641 35.0568C41.3641 34.6413 41.2194 34.2889 40.9301 33.9996C40.6408 33.7073 40.1823 33.5611 39.5544 33.5611H37.3939V36.7003Z"
      fill="currentColor"
    />
  </svg>
);
